const SELECTORS = {
  trigger: '.js-multi-download',
};

class MultiDownload {
  constructor() {
    this.buttons = document.querySelectorAll(SELECTORS.trigger);
    this.DOM = {
      body: document.body,
    };
    this.init();
  }

  init() {
    this.buttons.forEach((trigger) => {
      trigger.addEventListener(
        'click',
        this.handleTriggerClick.bind(this, trigger),
      );
    });
  }

  handleTriggerClick(trigger, event) {
    event.preventDefault();
    const files = trigger.dataset.files.split(',').filter((f) => f);
    files.forEach((file) => {
      this.downloadFile(file);
    });
  }

  downloadFile(file) {
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = file;
    link.download = file;
    this.DOM.body.appendChild(link);
    link.click();
    setTimeout(() => {
      URL.revokeObjectURL(link.href);
      link.parentNode.removeChild(link);
    }, 0);
  }
}

export default () => {
  return new MultiDownload();
};
